import { jsx } from "panel";
import { TagInputEl } from "common/components/tag-input";
import { ItemsMenuEl } from "common/components/items-menu";
import { ButtonBarEl } from "common/components/button-bar";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerColor } from "common/components/spinner/types";
export function template() {
  const {
    inputText
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-tag-selector-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TagInputEl, { sel: ".input-el", attrs: {
    error: this.attr("error"),
    "min-tags": this.attr("min-tags"),
    saving: this.attr("saving"),
    "show-search-icon": this.helpers.getNumTags() === 0,
    "search-text": this.helpers.searchText(),
    tags: this.helpers.getSelectedTagAttrs(),
    multiline: this.attr("multiline")
  }, style: {
    "max-height": this.attr("max-tag-input-height")
  }, on: {
    change: this.helpers.handleInputChange,
    keydown: this.helpers.handleKeyDown
  }, "data-sentry-element": "TagInputEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".mp-tag-selector-hr" }), /* @__PURE__ */ jsx(ItemsMenuEl, { attrs: {
    "empty-message": this.helpers.emptyText(),
    "search-filter": inputText,
    sections: this.helpers.getMenuSections()
  }, style: {
    "max-height": this.attr("max-tag-items-height")
  }, props: {
    keydownProxyEl: this.helpers.getKeydownProxyEl()
  }, on: {
    clickItem: (ev) => this.helpers.addTag(ev.detail)
  }, "data-sentry-element": "ItemsMenuEl", "data-sentry-source-file": "template.tsx" }), !this.attr("read-only") && (this.helpers.showCreateButton() ? /* @__PURE__ */ jsx(ButtonBarEl, { sel: ".create-btn", attrs: {
    color: "grey"
  }, on: {
    click: () => this.helpers.addNewTag(inputText)
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-tag-selector-create-tag-btn" }, /* @__PURE__ */ jsx("div", { sel: ".mp-tag-selector-copy" }, this.helpers.createNewText()), /* @__PURE__ */ jsx("div", { sel: ".mp-tag-selector-label-name" }, inputText))) : /* @__PURE__ */ jsx(ButtonBarEl, { sel: ".save-btn", attrs: {
    color: "blue",
    disabled: this.attr("saving"),
    title: "Save Tags (Alt+Enter)"
  }, on: {
    click: this.helpers.saveTags
  } }, this.attr("saving") ? /* @__PURE__ */ jsx(SpinnerEl, { attrs: {
    color: SpinnerColor.White
  } }) : "Save")));
}
